"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/* eslint-disable valid-jsdoc */
/* eslint-disable guard-for-in */
/* eslint-disable no-empty */
/* eslint-disable no-empty-function */
/* eslint-disable no-unused-vars */
/* eslint-disable sort-imports */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createParser = void 0;
const modelParserImpl_1 = require("./modelParserImpl");
const parserInitializer_1 = require("./parserInitializer");
/**
 * Function for creation of the model parser.
 **/
function createParser(parsingOptions) {
    parserInitializer_1.ParserInitializer.initialize();
    const impl = new modelParserImpl_1.ModelParserImpl();
    impl.options = parsingOptions;
    return impl;
}
exports.createParser = createParser;
//# sourceMappingURL=createParser.js.map